export const contactUrls = [
  '/recent-leads',
  '/unassigned-lead',
  '/my-lead',
  '/division-claimed-leads',
  '/unassigned-prospects',
  '/my-prospect',
  '/accounts',
  '/inactive-accounts',
  '/win-again-accounts',
  '/win-again-prospects',
  '/manager-bucket',
  '/to-reassign',
  '/paid-off-accounts',
  '/collection-list',
  '/credit-exposure',
  '/contacts',
  '/dead-contacts',
  '/not-qualified',
  '/i-give-up',
  '/out-of-business',
]

export const customerUrls = [
  '/unassigned-leads',
  '/recent-leads',
  '/unverified-leads',
  '/verified-leads',
  '/unassigned-prospects',
  '/my-prospects',
  '/accounts',
  '/pending-accounts',
  '/win-again-accounts',
  '/win-again-prospects',
  '/all-customers',
  '/dead-customers',
  '/not-qualified',
  '/i-give-up',
  '/division-claimed-leads',
  '/managers-bucket',
  '/to-reassign',
  '/cadence-leads',
  '/zoominfo-leads',
]

export const baseContactUrl = '/contacts'
